export const getDefaultPathGuard = (pathname: string): boolean => {
  return location.pathname.slice(1).startsWith(pathname);
};
